import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { firebaseConfig } from './firebaseConstant';



const app = initializeApp(firebaseConfig);
const auth = getAuth();
const db = getFirestore(app);

export { db,  auth};